import React, { Component } from 'react';
import { Route, Switch } from 'react-router';
import { ConnectedRouter } from 'react-router-redux';
import NotFound from './components/NotFound';
import PrivateRoute from './components/helpers/PrivateRoute';
import { AdminWrapper } from './components/admin/hocs/AdminWrapper';
import { setContext } from './actions/admin/context';
import { ROUTES_MAPPING } from './constants/routing';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PrivacyModal from './containers/authentication/PrivacyModal';

class ApplicationRouter extends Component {
    _privateRoute(path, component) {
        return (
            <PrivateRoute key={path} exact={true} path={path} component={component} access={this.props.authenticated} />
        );
    }
    _mapRoutes(mapping, isPrivate, hocFunction = false) {
        return mapping.map(rm => {
            if (isPrivate) {
                return this._privateRoute(rm[0], hocFunction ? hocFunction(rm[1], rm[2]) : rm[1]);
            } else {
                return <Route key={rm[0]} exact={true} path={rm[0]} component={rm[1]} />;
            }
        });
    }
    _adminWrappers = (component, permission) => AdminWrapper(component, this.props.setContext, permission);
    _render() {
        if (this.props.path) {
            const Layout = this.props.layout;
            return (
                <Layout>
                    <PrivacyModal />
                    <Switch>
                        {this._mapRoutes(ROUTES_MAPPING.PUBLIC, false)}
                        {this._mapRoutes(ROUTES_MAPPING.PRIVATE, true)}
                        {this._mapRoutes(ROUTES_MAPPING.ADMIN, true, this._adminWrappers)}
                        <Route component={NotFound} />
                    </Switch>
                </Layout>
            );
        } else {
            return null;
        }
    }
    render() {
        return <ConnectedRouter history={this.props.history}>{this._render()}</ConnectedRouter>;
    }
}

const mapStateToProps = state => ({});

const mapDispatchToProps = dispatch => bindActionCreators({ setContext }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(ApplicationRouter);
